// extracted by mini-css-extract-plugin
export default {"spinner":"KNxH0Y2aRXP4bGyuENoHJw==","double-bounce1":"roLUxZCMllFN8v9ivcg67g==","double-bounce2":"xIJI0eBoRQBKAdMHmni1Cg==","sk-bounce":"nIknIN3fT9LjK+-ZK+guzA=="};